import React from "react"

import FilterBody from "../FilterBody"

const FilterSidebar = (props) => {
  return (
    <aside className="hidden md:block w-64 shrink-0">
      <div className="sticky top-6 bg-white rounded-2xl border border-[#E7EAEF] p-4">
        <FilterBody {...props} />
      </div>
    </aside>
  )
}

export default FilterSidebar
